export const dummyProfile = {
  first_name: 'Placeholder',
  last_name: 'Name',
  avatar_url: '',
  country: 'Placeholder',
  total_users: 100,
  position: 1,
  total_score: 5000,
  badges: [
    {
      language: 'HTML',
      visibility: 'highlighted',
      rank: 1,
      location_name: 'World',
      version: 'v1',
    },
    {
      language: 'JavaScript',
      visibility: 'highlighted',
      rank: 1,
      location_name: 'World',
      version: 'v1',
    },
    {
      language: 'CSS',
      visibility: 'highlighted',
      rank: 1,
      location_name: 'World',
      version: 'v1',
    },
  ],
};
